// import "@/assets/scss/argon-design-system.scss";
// import "@/assets/vendor/nucleo/css/nucleo-icons.css";
// import "@/assets/vendor/font-awesome/css/font-awesome.css";
// import Bugsnag from '@bugsnag/js';
// import BugsnagPluginVue from '@bugsnag/plugin-vue';

// Notifications plugin. Used on Notifications page
import Notifications from "@/components/NotificationPlugin";
// Validation plugin used to validate forms
import {configure, extend} from "vee-validate";
// A plugin file where you could register global components used across the app
import GlobalComponents from "./globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "./globalDirectives";
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from "@/components/SidebarPlugin";

// element ui language configuration
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
// vue-bootstrap
import {BootstrapVue, IconsPlugin} from "bootstrap-vue";

// asset imports
import "@/assets/sass/argon.scss";
import "@/assets/css/nucleo/css/nucleo.css";
import "@/assets/css/site.css";
import "@/assets/css/darktheme.scss";
import * as rules from "vee-validate/dist/rules";
import * as vee from "vee-validate/dist/locale/en.json";
import {Loading} from "element-ui";
import Contextmenu from "vue-contextmenujs";

locale.use(lang);

Object.keys(rules).forEach(rule => {
	extend(rule, {
		...rules[rule], // copies rule configuration
		message: vee.messages[rule], // assign message
	});
});

export default {
	install(Vue) {
		Vue.use(GlobalComponents);
		Vue.use(GlobalDirectives);
		Vue.use(SideBar);
		Vue.use(Notifications);
		Vue.use(BootstrapVue);
		Vue.use(IconsPlugin);
		Vue.use(Loading.directive);
		Vue.use(Contextmenu);
		configure({
			classes: {
				valid: "is-valid",
				invalid: "is-invalid",
				dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
			},
		});
	},
};
